import { render } from "./SmartSlider.vue?vue&type=template&id=24e2b239&scoped=true"
import script from "./SmartSlider.vue?vue&type=script&lang=js"
export * from "./SmartSlider.vue?vue&type=script&lang=js"

import "./SmartSlider.vue?vue&type=style&index=0&id=24e2b239&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e2b239"]])

export default __exports__